var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('receipt-print-order',{ref:"receiptPrintOrder",on:{"selectRow":_vm.selectRow,"reset":_vm.reset}}),_c('receipt-print-detail',{ref:"receiptPrintODetail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }